import React from "react";
import { Link } from "react-router-dom";

type PropsType = {
  title: string;
  to: string;
  active?: boolean;
};

export default function NavLink({ title, to, active }: PropsType) {
  let theme = "text-gray-500 hover:text-black";
  if (active) {
    theme = "!text-black";
  }
  return (
    <Link className={`font-simianregular text-[20px] transition ${theme}`} to={to}>
      {title}
    </Link>
  );
}
